import { attach, createDomain, createEvent, sample } from 'effector';
import { devicesEntity } from '@entities/devices';
import { askAi } from '@entities/ai-chat/api';

const reset = createEvent();
const domain = createDomain();

const $history = domain.createStore<{ isAi: boolean, message: string }[]>([])
const $threadId = domain.createStore<string | null>(null)

const askQuestion = createEvent<string>()

const askQuestionFx = attach({
  source: {
    experiment: devicesEntity.$experiment,
    device: devicesEntity.$deviceInfo,
    tableData: devicesEntity.$tableData,
    history: $history,
    threadId: $threadId,
  },
  effect: async ({ experiment, threadId, history, tableData, device }, question: string) => {
    if (!device) throw Error("No device selected")
    if (!question.length) throw Error("No question")

    return askAi({
      threadId: threadId ?? undefined,
      experiment: {
        title: experiment?.name || "",
        description: experiment?.description || "",
        unitOfMeasurement: device.unit.toString(),
        data: tableData.map(row => ({
          second: row.time,
          value: row.value
        })),
      },
      messages: [
        ...history,
      ],

    })
  }
})

sample({
  clock: askQuestion,
  target: askQuestionFx
})

sample({
  clock: askQuestionFx.doneData,
  fn: ({ threadId }) => threadId ?? null,
  target: $threadId
})

sample({
  source: $history,
  clock: askQuestionFx,
  fn: (history, askedQuestion) => ([
    ...history,
    {
      isAi: false,
      message: askedQuestion
    }
  ]),
  target: $history
})


sample({
  source: $history,
  clock: askQuestionFx.doneData,
  fn: (history, newMessage) => ([
    ...history,
    {
      isAi: true,
      message: newMessage.response
    }
  ]),
  target: $history
})

domain.onCreateStore(store => store.reset(reset))

export const askAiModel = {
  $history,
  $threadId,
  $pending: askQuestionFx.pending,
  askQuestion,
  reset,
}